import { SvgIcon } from '@mui/material';
import { ReactElement } from 'react';
import { AppPrimaryButtonOutlined } from 'shared/components/AppComponents';
import PageHeader from 'shared/components/PageHeader';
import CachedIcon from '@mui/icons-material/Cached';
import AuditLogFilterList from './AuditLogFilterList';

const AuditLogs = (): ReactElement => {
  console.log('working audit logs');
  return (
    <>
      <PageHeader
        title="Audit Log"
        description="Immutable record of all proxy decisions."
        noPadding
        actions={
          <AppPrimaryButtonOutlined
            className="btn-small"
            // onClick={() => setApiCreateOpenDialog(true)}
            startIcon={
              <SvgIcon
                component={CachedIcon}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
              />
            }
            title="Refresh"
          />
        }
      />
      <AuditLogFilterList />
    </>
  );
};

export default AuditLogs;
